module.exports = __webpack_public_path__ + "static/media/Google Play Logo 2@300x.fcfb8087.png";